import React from 'react'
import abc from "../../Assets/images/abc.png";
import abcd from "../../Assets/images/abcd.png";
import abcde from "../../Assets/images/abcde.png";

function AboutHowWork() {
    return (
        <>
            <section className="bg-white aon-how-service-area">
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            {/*Title Section Start*/}
                            <div className="col-lg-4 col-md-12">
                                <span className="aon-sub-title">Steps</span>
                                <h2 className="sf-title">How Service Finder Works</h2>
                            </div>
                            {/*Title Section End*/}
                            <div className="col-lg-8 col-md-12">
                                {/* Steps Block Start*/}
                                <div className="aon-step-blocks">
                                    <div className="row">
                                        {/* COLUMNS 1 */}
                                        <div className="col-md-4 col-sm-4 m-b30">
                                            <div className="aon-step-section step-position-1 aon-icon-effect">
                                                <div className="aon-step-icon aon-icon-box">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img src={abc} alt="" />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-step-info">
                                                    <h4 className="aon-title">Describe Your Task</h4>
                                                    <p>
                                                        This helps us determine which Taskers are abest job.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* COLUMNS 2 */}
                                        <div className="col-md-4 col-sm-4 m-b30">
                                            <div className="aon-step-section step-position-2 aon-icon-effect">
                                                <div className="aon-step-icon">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img src={abcd} alt="" />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-step-info">
                                                    <h4 className="aon-title">Choose a Tasker</h4>
                                                    <p>
                                                        This helps us determine which Taskers are abest job.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* COLUMNS 3 */}
                                        <div className="col-md-4 col-sm-4 m-b30">
                                            <div className="aon-step-section  step-position-3  aon-icon-effect">
                                                <div className="aon-step-icon">
                                                    <span>
                                                        <i className="aon-icon">
                                                            <img src={abcde} alt="" />
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="aon-step-info">
                                                    <h4 className="aon-title">Live Smarter</h4>
                                                    <p>
                                                        This helps us determine which Taskers are abest job.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Steps Block End*/}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutHowWork
